import { Component, Input, OnChanges, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AffiliateService } from '@core/services/affiliate.service';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs';

@Component({
    selector: 'app-affiliates-form',
    templateUrl: './affiliates-form.component.html',
    styleUrls: ['./affiliates-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AffiliatesFormComponent implements OnChanges {
  constructor(private fb: FormBuilder, private toastr: ToastrService, private affiliateService: AffiliateService) {}
  @Input() isCollapsed = false;
  @Input() affiliateData: any = {};
  @Output() refreshData: EventEmitter<any> = new EventEmitter<any>();

  isEdit = false;
  public selectedFile: any;
  public formData!: FormData;

  pageContent!: any | null;
  imageFile!: File;
  affiliateForm!: FormGroup | any;
  isProcessing = false;

  get name() { return this.affiliateForm.get('name'); }
  get description() { return this.affiliateForm.get('description'); }
  get imageUrl() { return this.affiliateForm.get('imageUrl'); }
  get hrefLink() { return this.affiliateForm.get('hrefLink'); }
  get hrefText() { return this.affiliateForm.get('hrefText'); }
  get imageFileName() { return this.affiliateForm.get('imageFileName'); }

  ngOnInit() {
    this.initForm();
  }

  ngOnChanges() {
    if(this.affiliateData) {
      this.affiliateForm.patchValue({
        name: this.affiliateData.name,
        description: this.affiliateData.description,
        imageUrl: this.affiliateData.imageUrl,
        hrefLink: this.affiliateData.hrefLink,
        hrefText: this.affiliateData.hrefText,
        imageFileName: this.affiliateData.imageFileName
      });
    }
  }

  initForm() {
    const urlRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;

    this.affiliateForm = this.fb.group({
      name: [null, [Validators.required, Validators.maxLength(45)]],
      description: [null, [Validators.required, Validators.maxLength(250)]],
      hrefLink: [null, [Validators.required, Validators.maxLength(250), Validators.pattern(urlRegex)]],
      hrefText: [null, [Validators.required, Validators.maxLength(25)]],
      imageUrl: [null],
      imageFileName: [{value: null, disabled: true}, Validators.required]
    });
  }


  public fileChange(event: any) {
    if(!this.affiliateData) this.affiliateData = {};
		const fileList: FileList = event.target.files;
		if (fileList.length > 0) {
			const chosenFile: File = fileList[0];
			this.selectedFile = chosenFile;
			this.affiliateForm.get('imageFileName').markAsDirty();
			this.affiliateForm.patchValue({
        imageFileName: chosenFile.name,
			});
      this.affiliateData.imageFileName = chosenFile.name;
		}
	}

  public prepareData() {
    Object.assign(this.affiliateData, this.affiliateForm.value);
    this.formData = new FormData();
		if (this.selectedFile) {
			this.formData.append('affiliateImage', this.selectedFile, this.selectedFile.name);
		}

    this.formData.append('affiliate', JSON.stringify(this.affiliateData));
  }

  saveForm() {
    if (this.affiliateForm.invalid) {
      this.toastr.error('Please fix your form errors!');
      return;
    }
    this.prepareData();
    this.isProcessing = true;
    this.affiliateService.saveAffiliate(this.formData, 'Affiliate successfully saved!').pipe(
      take(1)
    ).subscribe((data: any) => {
        this.isProcessing = false;
        this.refreshData.emit(true);
    });
  }
}
